import BaseApi from './baseApi';
import IListTypesInbounds from '../models/IListTypesInbounds';
import IAuthentication from '../models/IAuthentication';
export default class ListTypesInboundsApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Settings");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListTypesInbounds() : Promise<IListTypesInbounds[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listTypesInbounds: IListTypesInbounds[] = [];
            listTypesInbounds = response.data as IListTypesInbounds[];
            return listTypesInbounds;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListTypesInbounds(listTypesInbounds: IListTypesInbounds) : Promise<string> {
        const json = this.getJsonSave(listTypesInbounds);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListTypesInbounds(listTypesInbounds: IListTypesInbounds) : Promise<boolean> {
        const json = this.getJsonUpdate(listTypesInbounds);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListTypesInbounds(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_TYPES_INBOUNDS_IN_USE",
            "parameters": [{
                "Item1": "TypesInboundsId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "ListTypesInbounds",
                "Item2": "id"
            }, {
                "Item1": "ListTypesInbounds",
                "Item2": "name"
            }, {
                "Item1": "ListTypesInbounds",
                "Item2": "canDelete"
            }],
            "tables": [{
                "Item1": "ListTypesInbounds"
            }],
            "conditions": [{
                "Item1": "ListTypesInbounds",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListTypesInbounds",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": this.idCompany
            }],
            "orderBy": [{
                "Item1": "ListTypesInbounds.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesInbounds",
            "conditions": [{
                "Item1": "ListTypesInbounds",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(listTypesInbounds: IListTypesInbounds) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listTypesInbounds.name
            }, {
                "Item1": "CanDelete",
                "Item2": 1
            }, {
                "Item1": "idCompany",
                "Item2": this.idCompany
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesInbounds"
        };
        return json;
    }

    private getJsonUpdate(listTypesInbounds: IListTypesInbounds) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": listTypesInbounds.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListTypesInbounds",
            "keyvalue": listTypesInbounds.id
        };
        return json;
    }
}
